// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-window .v-window__next{right:1em!important}.media-window .v-window__prev{left:-.5em!important;width:36px!important}.full-image{width:100%;max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.ios-rounded{-o-object-fit:cover;object-fit:cover}.back-button{z-index:10;left:2em;top:2em}.image-wrapper{min-width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
